import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from './App.tsx'
import './index.css'
import { supabase } from '@/integrations/supabase/client'
import { runProposalStatusHealthCheck } from '@/dev/healthChecks'
import { queryClient } from "./lib/react-query";

if (import.meta.env.DEV) {
  // Dev-only health check for proposal statuses
  runProposalStatusHealthCheck(supabase);
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
